var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exportList flex flex-align-center"},[_c('el-button',{on:{"click":_vm.skipRecord}},[_vm._v("导出记录")]),_c('el-button',{on:{"click":_vm.exportFun}},[_vm._v("导出")]),_c('export-dialog',{ref:"exportDialog",attrs:{"isExportImg":_vm.isExportImg,"isExportSku":_vm.isExportSku}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }